/** Session-scoped handoff from Krybot chat → Control Bridge surface focus. */

export const CONTROL_BRIDGE_PENDING_NAV_KEY = 'krybot:control-bridge-pending-nav';

/** Same-tab notify so Control Bridge can apply a stash without a remount. */
export const CONTROL_BRIDGE_PENDING_NAV_EVENT = 'krysalis:control-bridge-pending-nav';

export interface ControlBridgePendingNav {
  workspaceSlug?: string;
  surface?: string;
  resource?: string;
  artifactItemRef?: string;
}

export function stashControlBridgePendingNav(nav: ControlBridgePendingNav): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(CONTROL_BRIDGE_PENDING_NAV_KEY, JSON.stringify(nav));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(CONTROL_BRIDGE_PENDING_NAV_EVENT));
  }
}

export function peekControlBridgePendingNav(): ControlBridgePendingNav | null {
  if (typeof sessionStorage === 'undefined') return null;
  const raw = sessionStorage.getItem(CONTROL_BRIDGE_PENDING_NAV_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ControlBridgePendingNav;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function clearControlBridgePendingNav(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(CONTROL_BRIDGE_PENDING_NAV_KEY);
}

/** Peek + clear. Prefer peek/clear when item lookup may need a later retry. */
export function consumeControlBridgePendingNav(): ControlBridgePendingNav | null {
  const pending = peekControlBridgePendingNav();
  if (pending) {
    clearControlBridgePendingNav();
  }
  return pending;
}
